import React from 'react';
import { Spacer } from '@ontruck/orc';

import { FormatPrice } from 'utils/format';

const costMatrix = {
  'BCN-BCN': {
    van: 10,
    box_van: 12,
    rigid_truck: 26,
    trailer: 27,
  },
  'MAD-MAD': {
    van: 13,
    box_van: 13,
    rigid_truck: 17,
    trailer: 30,
  },
  'VLC-VLC': {
    van: 12,
    box_van: 16,
    rigid_truck: 32,
    trailer: 44,
  },
  'PAR-PAR': {
    van: 22,
    box_van: 37,
    rigid_truck: 43,
    trailer: 43,
  },
};

const t = {
  van: 'Van',
  box_van: 'Box van',
  rigid_truck: 'Rigid',
  trailer: 'Trailer',
};

const getRecommendedExtraCost = (route = {}) => {
  const extraCosts = costMatrix[`${route.origin}-${route.destination}`];

  if (extraCosts) {
    return extraCosts;
  }

  return false;
};

const ExtraCostRecommendations = ({ route, currency }) => {
  const costs = getRecommendedExtraCost(route);

  if (!costs) {
    return null;
  }

  return (
    <Spacer>
      {Object.keys(costs).map((vehicle) => (
        <div key={vehicle}>
          {t[vehicle]}: <FormatPrice currency={currency} value={costs[vehicle]} />
        </div>
      ))}
    </Spacer>
  );
};
export { getRecommendedExtraCost, ExtraCostRecommendations };
